(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["audio-demos-gem"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  let wavesurfers = {};
  const cards = document.querySelectorAll('.sk-track-card');
  
  // 1. Initialize Wavesurfer for visible AND hidden tracks
  // We initialize them all so playback is instant when switching tabs
  cards.forEach(card => {
    const container = card.querySelector('.sk-waveform-container');
    const url = container.dataset.url;
    const color = container.dataset.color;
    const id = container.id.replace('waveform-', '');
    
    if (!url) return;

    // Create dynamic gradient based on category color
    const ctx = document.createElement('canvas').getContext('2d');
    const gradient = ctx.createLinearGradient(0, 0, 0, 100);
    gradient.addColorStop(0, color); // Top is full color
    gradient.addColorStop(1, '#ffffff'); // Fade to white/lighter at bottom

    const ws = WaveSurfer.create({
      container: container,
      waveColor: '#444444',
      progressColor: gradient,
      cursorColor: 'transparent',
      barWidth: 3,
      barRadius: 3,
      barGap: 2,
      height: 40,
      normalize: true,
    });

    ws.load(url);
    wavesurfers[id] = ws;

    ws.on('finish', () => {
      card.classList.remove('playing');
    });
  });

  // 2. Handle Playback
  window.toggleKnobPlay = function(id) {
    const player = wavesurfers[id];
    const card = document.querySelector(`#waveform-${id}`).closest('.sk-track-card');
    
    // Pause others
    Object.keys(wavesurfers).forEach(key => {
      if (key !== id) {
        wavesurfers[key].pause();
        document.querySelector(`#waveform-${key}`).closest('.sk-track-card').classList.remove('playing');
      }
    });

    player.playPause();
    
    if (player.isPlaying()) {
      card.classList.add('playing');
    } else {
      card.classList.remove('playing');
    }
  };

  // 3. Handle Tab Filtering
  const tabs = document.querySelectorAll('.sk-tab-btn');
  
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      // Update Active Tab State
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      const category = tab.dataset.category;
      const accentColor = tab.dataset.color; // Capture color for potential use

      // Filter Grid
      cards.forEach(card => {
        // Handle "all" if needed, but logic here is strict category
        if (card.dataset.category === category) {
          card.style.display = 'flex';
          // Force a redraw of waveform if it was hidden (sometimes needed for wavesurfer)
          const id = card.querySelector('.sk-waveform-container').id.replace('waveform-', '');
          if(wavesurfers[id]) wavesurfers[id].drawBuffer();
        } else {
          card.style.display = 'none';
          // Ensure we stop playing tracks from hidden tabs
          const id = card.querySelector('.sk-waveform-container').id.replace('waveform-', '');
          if(wavesurfers[id]) {
            wavesurfers[id].pause();
            card.classList.remove('playing');
          }
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const timers = document.querySelectorAll('.bf-countdown-container');

  timers.forEach(timer => {
    const deadline = timer.getAttribute('data-deadline');
    if (!deadline) return;

    // Robust IOS/Safari compatible date parsing
    // Replaces space with T if T is missing, though schema output usually includes it
    const targetDateStr = deadline.replace(' ', 'T');
    const endDate = new Date(targetDateStr).getTime();

    if (isNaN(endDate)) {
      console.error("EDM Hero: Invalid Date Format. Use YYYY-MM-DDTHH:MM:SS");
      return;
    }

    const x = setInterval(function() {
      const now = new Date().getTime();
      const distance = endDate - now;

      if (distance < 0) {
        clearInterval(x);
        // Optional: Hide timer or show "Sale Ended"
        timer.style.opacity = '0.5'; 
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      timer.querySelector('#days').innerText = days < 10 ? "0" + days : days;
      timer.querySelector('#hours').innerText = hours < 10 ? "0" + hours : hours;
      timer.querySelector('#minutes').innerText = minutes < 10 ? "0" + minutes : minutes;
      timer.querySelector('#seconds').innerText = seconds < 10 ? "0" + seconds : seconds;
    }, 1000);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
